
const TestRunStatusTypes = Object.freeze({
    PASSED: 'Passed',
    FAILED: 'Failed',
    PENDING: 'Pending',
    SKIPPED: 'Skipped',
  });

  const TestcasesExecutionStatus = Object.freeze({
    COMPLETED: 'Completed',
    INPROGRESS: 'In Progress',
    NEW : 'New',
  });

  //const DEFAULT_STATUS = TestRunStatusTypes.NEW;

  const statusColors = Object.freeze({
    Pending: '#0000007A',
    Passed: '#7E9B08',
    Failed: '#D32F2F',
    Skipped: '#E4B304',
    Inprogress:'#2563eb',
    Aborted:'#ca8a04'
  });
  
  module.exports = {
    TestRunStatusTypes,
    TestcasesExecutionStatus,
    statusColors,
  };
